import { useState } from "react";
import { Copy, Check, Gavel } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const BuyerScript = ({ script }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(script);
      setCopied(true);
      toast.success("Buyer action script copied");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy. Please select the text manually.");
    }
  };

  return (
    <div data-testid="buyer-action-script" className="overflow-hidden rounded-xl border border-primary/40 bg-card">
      <div className="flex items-center justify-between border-b border-border bg-primary/10 px-6 py-4">
        <div className="flex items-center gap-2">
          <Gavel className="h-5 w-5 text-primary" aria-hidden="true" />
          <h3 className="font-heading text-lg font-800 uppercase tracking-wide text-foreground">Buyer Action Script</h3>
        </div>
        <Button
          data-testid="copy-script-btn"
          size="sm"
          onClick={copy}
          className="rounded-full"
        >
          {copied ? <Check className="mr-1.5 h-3.5 w-3.5" /> : <Copy className="mr-1.5 h-3.5 w-3.5" />}
          {copied ? "Copied" : "Copy"}
        </Button>
      </div>
      <pre className="whitespace-pre-wrap px-6 py-5 font-sans text-sm leading-relaxed text-foreground/90">
        {script}
      </pre>
    </div>
  );
};
